
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class HazardFormFilterService {

    constructor(
        private _http: HttpClient
    ) { }

    getInitialDataForHazardsFilter() {
        return this._http.get(environment.serverUrl + '/tasks/getInitialDataForHazardsFilter');
    }
}



// WEBPACK FOOTER //
// ./src/app/hazard-form-filter/hazard-form-filter.service.ts